<header 
  class="fixed top-0 left-0 right-0 z-49 border-b border-side-navigation-panel-default-border/60 bg-linear-to-r from-surface-page-bg/90 to-side-navigation-panel-default-bg/90 backdrop-blur-md transition-all duration-200"
  [class.sidebar-expanded-left]="!layoutService.isSidebarCollapsed()"
  [class.sidebar-collapsed-left]="layoutService.isSidebarCollapsed()"
>
  <div class="header-container flex h-16 min-h-16 w-full max-w-full items-center justify-between gap-4 px-4 md:px-6">
    <div class="min-w-0 shrink-0 text-left">
      <a
        routerLink="/"
        class="md:hidden block text-left text-lg font-bold text-text-primary tracking-tight"
        aria-label="HypeTrack home"
      >
        {{ mobileBrand }}
      </a>
      <div class="hidden md:flex items-center gap-2 text-xl md:text-2xl font-extrabold text-text-primary tracking-tight">
        <button
          type="button"
          [routerLink]="headerRoute()"
          (click)="onHeaderTitleClick()"
          class="text-left text-text-primary hover:opacity-80 transition-opacity cursor-pointer"
        >
          {{ headerTitle() }}
        </button>

        @if (headerSubTitle()) {
          <span class="text-text-dimmed font-normal">></span>
          <span class="text-text-primary truncate flex items-center gap-1.5 font-bold">
            {{ headerSubTitle() }}
            @if (isHeaderArtistVerified()) {
              <svg role="img" aria-hidden="false" class="w-5 h-5 text-text-brand shrink-0 inline-block" viewBox="0 0 24 24">
                <title>Verified account</title>
                <path d="M10.814.5a1.66 1.66 0 0 1 2.372 0l2.512 2.572 3.595-.043a1.66 1.66 0 0 1 1.678 1.678l-.043 3.595 2.572 2.512c.667.65.667 1.722 0 2.372l-2.572 2.512.043 3.595a1.66 1.66 0 0 1-1.678 1.678l-3.595-.043-2.512 2.572a1.66 1.66 0 0 1-2.372 0l-2.512-2.572-3.595.043a1.66 1.66 0 0 1-1.678-1.678l.043-3.595L.5 13.186a1.66 1.66 0 0 1 0-2.372l2.572-2.512-.043-3.595a1.66 1.66 0 0 1 1.678-1.678l3.595.043zm6.584 9.12a1 1 0 0 0-1.414-1.413l-6.011 6.01-1.894-1.893a1 1 0 0 0-1.414 1.414l3.308 3.308z" fill="currentColor"></path>
              </svg>
            }
          </span>
        }
      </div>
    </div>

    <div class="flex min-w-0 flex-1 items-center justify-end gap-3">
      <div class="min-w-0 w-full max-w-sm sm:max-w-md flex-1 relative">
          <app-search-bar
            placeholder="What are you looking for?"
            [value]="searchQuery()"
            [loading]="isSearching()"
            [clearable]="true"
            (valueChange)="onSearchInput($event)"
            (clear)="onSearchClear()"
            (focus)="openSearch()"
            (blur)="closeSearch()"
            (click)="onSearchBarClick()"
            (searchKeydown)="onKeyDown($event)"
          />

          @if (isSearchActive() && searchQuery().trim().length > 0) {
            <div
              (click)="$event.stopPropagation()"
              (mousedown)="$event.preventDefault()"
              class="absolute top-full left-0 right-0 mt-2 bg-combobox-panel-bg border border-combobox-panel-border rounded-xl shadow-2xl backdrop-blur-md overflow-hidden z-130 max-h-[460px] flex flex-col"
            >
              
              <!-- Loading Skeleton (when searching and no results yet) -->
              @if (isSearching() && flatResults().length === 0) {
                <div class="p-3 space-y-2">
                  <div class="h-3 w-16 bg-white/10 rounded animate-pulse mb-3"></div>
                  @for (k of [1, 2, 3]; track k) {
                    <div class="flex items-center gap-3 p-2 rounded-lg bg-white/2 animate-pulse">
                      <div class="w-8 h-8 rounded-full bg-white/10 shrink-0"></div>
                      <div class="flex-1 space-y-1.5">
                        <div class="h-3.5 w-1/2 bg-white/10 rounded"></div>
                        <div class="h-2.5 w-1/4 bg-white/5 rounded"></div>
                      </div>
                    </div>
                  }
                </div>
              } @else if (flatResults().length > 0) {
                <div class="overflow-y-auto custom-scrollbar flex-1">
                  <!-- ARTISTS SECTION -->
                  @if (searchResults().artists.length > 0) {
                    <div>
                      <div class="px-4 py-2 bg-white/2 border-b border-combobox-list-item-border/40 flex items-center justify-between text-[10px] font-bold text-text-dimmed uppercase tracking-wider sticky top-0 backdrop-blur-md z-10">
                        <span>Artists</span>
                        <span class="text-[9px] text-text-half-dimmed font-medium bg-white/5 px-1.5 py-0.5 rounded">{{ searchResults().artists.length }}</span>
                      </div>
                      <ul>
                        @for (artist of searchResults().artists; track artist.id; let i = $index) {
                          <li
                            [attr.data-search-index]="getArtistNavIndex(i)"
                            (mousedown)="$event.preventDefault()"
                            class="border-b border-combobox-list-item-border/30 last:border-0"
                          >
                            <div
                              (click)="onArtistClick(artist.id)"
                              (mouseenter)="onItemMouseMove(getArtistNavIndex(i), $event)"
                              (mousemove)="onItemMouseMove(getArtistNavIndex(i), $event)"
                              class="flex justify-between items-center w-full px-4 py-2.5 transition-colors text-xs font-semibold cursor-pointer"
                              [class.bg-combobox-list-item-hover-bg]="getArtistNavIndex(i) === selectedIndex()"
                            >
                              <div class="flex items-center gap-3 min-w-0">
                                @if (artist.imageUrl) {
                                  <img [src]="artist.imageUrl" [alt]="artist.name" class="w-8 h-8 rounded-full object-cover shrink-0 border border-white/10 bg-zinc-800" />
                                } @else {
                                  <div class="w-8 h-8 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs shrink-0">
                                    {{ artist.name.charAt(0) }}
                                  </div>
                                }
                                <div class="flex flex-col min-w-0">
                                  <span class="font-bold text-sm text-text-primary truncate flex items-center gap-1.5">
                                    {{ artist.name }}
                                    @if (artist.verified) {
                                      <svg class="w-3.5 h-3.5 text-text-brand shrink-0 inline-block" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                      </svg>
                                    }
                                  </span>
                                  <span class="text-[11px] text-text-dimmed truncate">
                                    {{ artist.genres[0] || 'Artist' }}
                                  </span>
                                </div>
                              </div>
                              <span class="text-[10px] uppercase font-bold tracking-wider text-text-half-dimmed bg-white/5 px-2 py-0.5 rounded shrink-0">
                                Artist
                              </span>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }

                  <!-- SONGS SECTION -->
                  @if (searchResults().songs.length > 0) {
                    <div>
                      <div class="px-4 py-2 bg-white/2 border-y border-combobox-list-item-border/40 flex items-center justify-between text-[10px] font-bold text-text-dimmed uppercase tracking-wider sticky top-0 backdrop-blur-md z-10">
                        <span>Songs</span>
                        <span class="text-[9px] text-text-half-dimmed font-medium bg-white/5 px-1.5 py-0.5 rounded">{{ searchResults().songs.length }}</span>
                      </div>
                      <ul>
                        @for (song of searchResults().songs; track song.id; let i = $index) {
                          <li
                            [attr.data-search-index]="getSongNavIndex(i)"
                            (mousedown)="$event.preventDefault()"
                            class="border-b border-combobox-list-item-border/30 last:border-0"
                          >
                            <div
                              (click)="onSongClick(song.id)"
                              (mouseenter)="onItemMouseMove(getSongNavIndex(i), $event)"
                              (mousemove)="onItemMouseMove(getSongNavIndex(i), $event)"
                              class="flex justify-between items-center w-full px-4 py-2.5 transition-colors text-xs font-semibold cursor-pointer"
                              [class.bg-combobox-list-item-hover-bg]="getSongNavIndex(i) === selectedIndex()"
                            >
                              <div class="flex items-center gap-3 min-w-0">
                                @if (song.imageUrl) {
                                  <img [src]="song.imageUrl" [alt]="song.title" class="w-8 h-8 rounded-md object-cover shrink-0 border border-white/10 bg-zinc-800" />
                                } @else {
                                  <div class="w-8 h-8 rounded-md bg-white/5 text-text-dimmed flex items-center justify-center shrink-0">
                                    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <path d="M9 18V5l12-2v13"></path>
                                      <circle cx="6" cy="18" r="3"></circle>
                                      <circle cx="18" cy="16" r="3"></circle>
                                    </svg>
                                  </div>
                                }
                                <div class="flex flex-col min-w-0">
                                  <span class="font-bold text-sm text-text-primary truncate">
                                    {{ song.title }}
                                  </span>
                                  <span class="text-[11px] text-text-dimmed truncate">
                                    by {{ getSongArtistsLabel(song.artists) }}
                                  </span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 shrink-0">
                                @if (song.streams) {
                                  <span class="text-[11px] text-text-dimmed hidden sm:inline font-normal">
                                    {{ formatStreams(song.streams) }}
                                  </span>
                                }
                                <span class="text-[10px] uppercase font-bold tracking-wider text-text-half-dimmed bg-white/5 px-2 py-0.5 rounded shrink-0">
                                  Song
                                </span>
                              </div>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }

                  <!-- ALBUMS SECTION -->
                  @if (searchResults().albums.length > 0) {
                    <div>
                      <div class="px-4 py-2 bg-white/2 border-y border-combobox-list-item-border/40 flex items-center justify-between text-[10px] font-bold text-text-dimmed uppercase tracking-wider sticky top-0 backdrop-blur-md z-10">
                        <span>Albums</span>
                        <span class="text-[9px] text-text-half-dimmed font-medium bg-white/5 px-1.5 py-0.5 rounded">{{ searchResults().albums.length }}</span>
                      </div>
                      <ul>
                        @for (album of searchResults().albums; track album.id; let i = $index) {
                          <li
                            [attr.data-search-index]="getAlbumNavIndex(i)"
                            (mousedown)="$event.preventDefault()"
                            class="border-b border-combobox-list-item-border/30 last:border-0"
                          >
                            <div
                              (click)="onAlbumClick(album.id)"
                              (mouseenter)="onItemMouseMove(getAlbumNavIndex(i), $event)"
                              (mousemove)="onItemMouseMove(getAlbumNavIndex(i), $event)"
                              class="flex justify-between items-center w-full px-4 py-2.5 transition-colors text-xs font-semibold cursor-pointer"
                              [class.bg-combobox-list-item-hover-bg]="getAlbumNavIndex(i) === selectedIndex()"
                            >
                              <div class="flex items-center gap-3 min-w-0">
                                @if (album.imageUrl) {
                                  <img [src]="album.imageUrl" [alt]="album.title" class="w-8 h-8 rounded-md object-cover shrink-0 border border-white/10 bg-zinc-800 shadow-sm" />
                                } @else {
                                  <div class="w-8 h-8 rounded-md bg-white/5 text-text-dimmed flex items-center justify-center shrink-0">
                                    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                      <circle cx="12" cy="12" r="4"></circle>
                                      <circle cx="12" cy="12" r="1.5"></circle>
                                    </svg>
                                  </div>
                                }
                                <div class="flex flex-col min-w-0">
                                  <span class="font-bold text-sm text-text-primary truncate">
                                    {{ album.title }}
                                  </span>
                                  <span class="text-[11px] text-text-dimmed truncate">
                                    {{ getSongArtistsLabel(album.artists) || 'Various Artists' }}
                                    @if (album.releaseDate) {
                                      <span class="text-text-half-dimmed"> · {{ getAlbumYear(album.releaseDate) }}</span>
                                    }
                                  </span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 shrink-0">
                                @if (album.totalTracks) {
                                  <span class="text-[11px] text-text-dimmed hidden sm:inline font-normal">
                                    {{ album.totalTracks }} {{ album.totalTracks === 1 ? 'track' : 'tracks' }}
                                  </span>
                                }
                                <span class="text-[10px] uppercase font-bold tracking-wider text-text-half-dimmed bg-white/5 px-2 py-0.5 rounded shrink-0">
                                  Album
                                </span>
                              </div>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              } @else {
                <!-- Empty State -->
                <div class="p-6 text-center flex flex-col items-center justify-center gap-3">
                  <div class="w-10 h-10 rounded-full bg-side-navigation-item-active-bg flex items-center justify-center text-text-half-dimmed">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  </div>
                  <div>
                    <p class="text-text-primary font-medium text-sm">No results found for "{{ searchQuery() }}"</p>
                    <p class="text-text-dimmed text-xs mt-0.5">Looking for an unlisted artist?</p>
                  </div>

                  <div (mousedown)="$event.preventDefault()" class="w-full">
                    <app-button
                      variant="outlined"
                      size="small"
                      label="Add Missing Artist"
                      className="mt-2 w-full"
                      (btnClick)="openSuggestArtist()"
                    >
                      <svg left-icon width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </app-button>
                  </div>
                </div>
              }
            </div>
          }
      </div>

      <!-- Compare -->
      <a
        routerLink="/compare"
        routerLinkActive="!text-text-primary bg-badge-naked-hover"
        class="hidden sm:inline-flex items-center gap-1.5 h-9 px-3 rounded-full shrink-0 text-sm font-medium text-text-half-dimmed hover:text-text-primary hover:bg-badge-naked-hover transition-colors cursor-pointer"
        title="Compare Artists"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m16 3 4 4-4 4" />
          <path d="M20 7H4" />
          <path d="m8 21-4-4 4-4" />
          <path d="M4 17h16" />
        </svg>
        Compare
      </a>

      <!-- Profile Avatar Icon -->
      <button type="button" class="w-8 h-8 rounded-full bg-card-bg-default border border-card-border-border text-text-primary flex items-center justify-center font-bold text-xs shrink-0 hover:opacity-90 transition-opacity cursor-pointer" title="Account">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </button>

      <button
        type="button"
        class="md:hidden shrink-0 rounded-lg border border-card-border-border bg-card-bg-default p-2 text-text-primary transition-colors hover:bg-card-bg-hover"
        (click)="toggleMenu()"
        [attr.aria-expanded]="isMobileMenuOpen()"
        [attr.aria-label]="isMobileMenuOpen() ? 'Close menu' : 'Open menu'"
      >
        @if (isMobileMenuOpen()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M4 6h16" />
            <path d="M4 12h16" />
            <path d="M4 18h16" />
          </svg>
        }
      </button>
    </div>
  </div>

  @if (isMobileMenuOpen()) {
    <div
      class="md:hidden fixed left-0 right-0 top-18 h-[calc(100vh-4.5rem)] z-109 flex flex-col bg-side-navigation-panel-default-bg"
      role="dialog"
      aria-modal="true"
      aria-label="Main navigation"
      (click)="closeMobileMenu()"
    >
      <nav
        class="flex h-full min-h-0 flex-col"
        (click)="$event.stopPropagation()"
      >
        <div class="flex min-h-0 flex-1 flex-col px-4 pb-6 pt-6">
          <div class="flex-1 min-h-0 overflow-y-auto custom-scrollbar space-y-1 py-1">
            <!-- EXPLORE SECTION -->
            <div class="h-9 flex items-center px-3 my-1">
              <span class="text-[13px] font-medium text-text-dimmed">
                Explore
              </span>
            </div>

            <!-- Artists -->
            <a
              routerLink="/overview/artists"
              (click)="onMobileMenuArtistsClick()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 21"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.2375 6.9375C3.885 7.29 3.315 7.29 2.96625 6.9375L0.5625 4.5375C0.21375 4.185 0.21375 3.615 0.5625 3.2625C0.91125 2.91 1.485 2.91375 1.8375 3.2625L2.7 4.12875V0.9C2.7 0.40125 3.10125 0 3.6 0C4.09875 0 4.5 0.40125 4.5 0.9V4.12875L5.3625 3.26625C5.715 2.91375 6.285 2.91375 6.63375 3.26625C6.9825 3.61875 6.98625 4.18875 6.63375 4.5375L4.23375 6.9375H4.2375ZM16.2375 6.9375C15.885 7.29 15.315 7.29 14.9662 6.9375L12.5625 4.5375C12.21 4.185 12.21 3.615 12.5625 3.26625C12.915 2.9175 13.485 2.91375 13.8337 3.26625L14.6962 4.12875V0.9C14.6962 0.40125 15.0975 0 15.5962 0C16.095 0 16.4962 0.40125 16.4962 0.9V4.12875L17.3587 3.26625C17.7112 2.91375 18.2812 2.91375 18.63 3.26625C18.9787 3.61875 18.9825 4.18875 18.63 4.5375L16.23 6.9375H16.2375ZM9.6 8.4C10.7587 8.4 11.7 9.34125 11.7 10.5C11.7 11.6587 10.7587 12.6 9.6 12.6C8.44125 12.6 7.5 11.6587 7.5 10.5C7.5 9.34125 8.44125 8.4 9.6 8.4ZM9.6 14.4C11.5875 14.4 13.2 16.0125 13.2 18V19.2C13.2 19.8637 12.6637 20.4 12 20.4H7.2C6.53625 20.4 6 19.8637 6 19.2V18C6 16.0125 7.6125 14.4 9.6 14.4ZM1.2 12C1.2 11.0062 2.00625 10.2 3 10.2C3.99375 10.2 4.8 11.0062 4.8 12C4.8 12.9937 3.99375 13.8 3 13.8C2.00625 13.8 1.2 12.9937 1.2 12ZM14.4 12C14.4 11.0062 15.2062 10.2 16.2 10.2C17.1937 10.2 18 11.0062 18 12C18 12.9937 17.1937 13.8 16.2 13.8C15.2062 13.8 14.4 12.9937 14.4 12ZM3 15C3.57375 15 4.11 15.1612 4.5675 15.4425C4.33125 16.05 4.2 16.71 4.2 17.4V19.2C4.2 19.6275 4.29 20.0325 4.45125 20.4H1.15875C0.5175 20.4 0 19.8825 0 19.2412V18C0 16.3425 1.3425 15 3 15ZM14.7487 20.4C14.91 20.0325 15 19.6275 15 19.2V17.4C15 16.71 14.8687 16.05 14.6325 15.4425C15.09 15.1612 15.6262 15 16.2 15C17.8575 15 19.2 16.3425 19.2 18V19.2412C19.2 19.8787 18.6825 20.4 18.0412 20.4H14.7487Z"
                  />
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Artists
              </span>
            </a>

            <!-- Labels -->
            <a
              routerLink="/overview/labels"
              (click)="closeMobileMenu()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 15 20"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.4 0C1.07625 0 0 1.07625 0 2.4V16.8C0 18.1237 1.07625 19.2 2.4 19.2H12C13.3237 19.2 14.4 18.1237 14.4 16.8V2.4C14.4 1.07625 13.3237 0 12 0H2.4ZM6.6 13.2H7.8C8.46375 13.2 9 13.7362 9 14.4V17.4H5.4V14.4C5.4 13.7362 5.93625 13.2 6.6 13.2ZM3.6 4.2C3.6 3.87 3.87 3.6 4.2 3.6H5.4C5.73 3.6 6 3.87 6 4.2V5.4C6 5.73 5.73 6 5.4 6H4.2C3.87 6 3.6 5.73 3.6 5.4V4.2ZM9 3.6H10.2C10.53 3.6 10.8 3.87 10.8 4.2V5.4C10.8 5.73 10.53 6 10.2 6H9C8.67 6 8.4 5.73 8.4 5.4V4.2C8.4 3.87 8.67 3.6 9 3.6ZM3.6 9C3.6 8.67 3.87 8.4 4.2 8.4H5.4C5.73 8.4 6 8.67 6 9V10.2C6 10.53 5.73 10.8 5.4 10.8H4.2C3.87 10.8 3.6 10.53 3.6 10.2V9ZM9 8.4H10.2C10.53 8.4 10.8 8.67 10.8 9V10.2C10.8 10.53 10.53 10.8 10.2 10.8H9C8.67 10.8 8.4 10.53 8.4 10.2V9C8.4 8.67 8.67 8.4 9 8.4Z"
                  />
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Labels
              </span>
            </a>

            <!-- Brands -->
            <a
              routerLink="/overview/brands"
              (click)="closeMobileMenu()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 1.8H11.7C11.865 1.8 12 1.935 12 2.1V3.6H7.2V2.1C7.2 1.935 7.335 1.8 7.5 1.8ZM5.4 2.1V3.6H2.4C1.07625 3.6 0 4.67625 0 6V9.6H19.2V6C19.2 4.67625 18.1237 3.6 16.8 3.6H13.8V2.1C13.8 0.94125 12.8587 0 11.7 0H7.5C6.34125 0 5.4 0.94125 5.4 2.1ZM19.2 11.4H12V12C12 12.6638 11.4637 13.2 10.8 13.2H8.4C7.73625 13.2 7.2 12.6638 7.2 12V11.4H0V15.6C0 16.9238 1.07625 18 2.4 18H16.8C18.1237 18 19.2 16.9238 19.2 15.6V11.4Z"
                  />
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Brands
              </span>
            </a>

            <!-- Compare -->
            <a
              routerLink="/compare"
              (click)="closeMobileMenu()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m16 3 4 4-4 4" />
                  <path d="M20 7H4" />
                  <path d="m8 21-4-4 4-4" />
                  <path d="M4 17h16" />
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Compare
              </span>
            </a>

            <!-- CHARTS SECTION -->
            <div class="h-9 flex items-center px-3 my-1">
              <span class="text-[13px] font-medium text-text-dimmed">
                Charts
              </span>
            </div>

            <!-- IFPI Chart -->
            <a
              routerLink="/charts/ifpi"
              (click)="onMobileMenuSongsClick()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 17"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.4 1.2C2.4 0.53625 1.86375 0 1.2 0C0.53625 0 0 0.53625 0 1.2V13.8C0 15.4575 1.3425 16.8 3 16.8H18C18.6637 16.8 19.2 16.2637 19.2 15.6C19.2 14.9362 18.6637 14.4 18 14.4H3C2.67 14.4 2.4 14.13 2.4 13.8V1.2ZM17.6475 4.4475C18.1162 3.97875 18.1162 3.2175 17.6475 2.74875C17.1787 2.28 16.4175 2.28 15.9487 2.74875L12 6.70125L9.8475 4.5525C9.37875 4.08375 8.6175 4.08375 8.14875 4.5525L4.54875 8.1525C4.08 8.62125 4.08 9.3825 4.54875 9.85125C5.0175 10.32 5.77875 10.32 6.2475 9.85125L9 7.09875L11.1525 9.25125C11.6212 9.72 12.3825 9.72 12.8512 9.25125L17.6512 4.45125L17.6475 4.4475Z"
                  />
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                IFPI Chart
              </span>
            </a>

            <!-- STREAMING CHARTS SECTION -->
            <div class="flex flex-col w-full">
              <!-- Header Row: "Streaming Charts" + Chevron -->
              <button
                type="button"
                (click)="toggleStreamingMenu()"
                class="flex items-center justify-between h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full px-0"
                [class.bg-side-navigation-item-active-bg]="!isStreamingOpen() && isStreamingRouteActive()"
                [class.!text-text-primary]="!isStreamingOpen() && isStreamingRouteActive()"
              >
                <div class="flex items-center gap-3 truncate">
                  <div class="w-10 h-10 flex items-center justify-center shrink-0">
                    <svg
                      data-dc-tpl="68"
                      width="20"
                      height="20"
                      viewBox="0 0 512 512"
                      fill="currentColor"
                    >
                      <path
                        data-dc-tpl="69"
                        d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"
                      />
                    </svg>
                  </div>
                  <span class="truncate whitespace-nowrap">
                    Streaming Charts
                  </span>
                </div>

                <div class="pr-3 flex items-center justify-center shrink-0 transition-all duration-200">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="transition-transform duration-300"
                    [class.rotate-180]="isStreamingOpen()"
                  >
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </div>
              </button>

              <!-- Submenu items container -->
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out flex flex-col space-y-1 w-full"
                [class.h-[176px]]="isStreamingOpen()"
                [class.pt-1]="isStreamingOpen()"
                [class.opacity-100]="isStreamingOpen()"
                [class.pointer-events-auto]="isStreamingOpen()"
                [class.h-0]="!isStreamingOpen()"
                [class.pt-0]="!isStreamingOpen()"
                [class.opacity-0]="!isStreamingOpen()"
                [class.pointer-events-none]="!isStreamingOpen()"
              >
                <!-- Billboard Charts -->
                <a
                  routerLink="/charts/billboard"
                  (click)="closeMobileMenu()"
                  routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
                  class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
                >
                  <span class="truncate">Billboard Charts</span>
                </a>

                <!-- Spotify Charts -->
                <a
                  routerLink="/charts/spotify"
                  (click)="closeMobileMenu()"
                  routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
                  class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
                >
                  <span class="truncate">Spotify Charts</span>
                </a>

                <!-- Shazam Charts -->
                <a
                  routerLink="/charts/shazam"
                  (click)="closeMobileMenu()"
                  routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
                  class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
                >
                  <span class="truncate">Shazam Charts</span>
                </a>

                <!-- Apple Charts -->
                <a
                  routerLink="/charts/apple-music"
                  (click)="closeMobileMenu()"
                  routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
                  class="flex items-center h-10 pl-[52px] pr-4 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer font-medium text-sm overflow-hidden w-full whitespace-nowrap"
                >
                  <span class="truncate">Apple Charts</span>
                </a>
              </div>
            </div>

            <!-- Radio -->
            <a
              routerLink="/charts/radio"
              (click)="closeMobileMenu()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg width="18" height="18" viewBox="0 0 17 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 1.2C0 0.53625 0.53625 0 1.2 0C9.8175 0 16.8 6.9825 16.8 15.6C16.8 16.2637 16.2637 16.8 15.6 16.8C14.9362 16.8 14.4 16.2637 14.4 15.6C14.4 8.31 8.49 2.4 1.2 2.4C0.53625 2.4 0 1.86375 0 1.2ZM0 14.4C0 13.0762 1.07625 12 2.4 12C3.72375 12 4.8 13.0762 4.8 14.4C4.8 15.7237 3.72375 16.8 2.4 16.8C1.07625 16.8 0 15.7237 0 14.4ZM1.2 4.8C7.16625 4.8 12 9.63375 12 15.6C12 16.2637 11.4637 16.8 10.8 16.8C10.1362 16.8 9.6 16.2637 9.6 15.6C9.6 10.9612 5.83875 7.2 1.2 7.2C0.53625 7.2 0 6.66375 0 6C0 5.33625 0.53625 4.8 1.2 4.8Z"/>
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Radio
              </span>
            </a>

            <!-- TRENDS SECTION -->
            <div class="h-9 flex items-center px-3 my-1">
              <span class="text-[13px] font-medium text-text-dimmed">
                Trends
              </span>
            </div>

            <!-- Year in Review -->
            <a
              routerLink="/overview/year"
              (click)="closeMobileMenu()"
              routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
              class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
            >
              <div class="w-10 h-10 flex items-center justify-center shrink-0">
                <svg width="18" height="18" viewBox="0 0 17 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.8 0C4.13625 0 3.6 0.53625 3.6 1.2V2.4H2.4C1.07625 2.4 0 3.47625 0 4.8V6.6H16.8V4.8C16.8 3.47625 15.7237 2.4 14.4 2.4H13.2V1.2C13.2 0.53625 12.6637 0 12 0C11.3362 0 10.8 0.53625 10.8 1.2V2.4H6V1.2C6 0.53625 5.46375 0 4.8 0ZM0 8.4V15.6C0 16.9238 1.07625 18 2.4 18H14.4C15.7237 18 16.8 16.9238 16.8 15.6V8.4H0Z"/>
                </svg>
              </div>
              <span class="truncate pr-4 whitespace-nowrap">
                Year in Review
              </span>
            </a>

            <!-- ADMIN SECTION -->
            @if (authService.isAdmin()) {
              <div class="h-9 flex items-center px-3 my-1">
                <span class="text-[13px] font-medium text-text-dimmed">
                  Admin
                </span>
              </div>

              <!-- Management -->
              <a
                routerLink="/admin"
                (click)="closeMobileMenu()"
                routerLinkActive="bg-side-navigation-item-active-bg !text-text-primary"
                class="flex items-center gap-3 h-10 rounded-full text-text-half-dimmed hover:bg-side-navigation-item-hover-bg hover:text-text-primary transition-all duration-200 cursor-pointer group font-medium text-sm overflow-hidden w-full"
              >
                <div class="w-10 h-10 flex items-center justify-center shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="18" height="18" x="3" y="3" rx="2" />
                    <path d="M3 9h18" />
                    <path d="M9 21V9" />
                  </svg>
                </div>
                <span class="truncate pr-4 whitespace-nowrap">
                  Management
                </span>
              </a>
            }
          </div>

          <div class="mt-auto flex flex-col gap-3 border-t border-side-navigation-panel-default-border pt-4">
            @if (authService.isAuthenticated()) {
              <div class="flex items-center justify-between gap-3 rounded-xl border border-side-navigation-panel-default-border bg-card-bg-default p-3">
                <div class="flex min-w-0 items-center gap-3">
                  <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/20 text-xs font-bold text-primary">
                    {{ authService.currentUser()?.username?.charAt(0) || 'U' }}
                  </div>
                  <div class="flex min-w-0 flex-col">
                    <span class="truncate text-sm font-bold text-text-primary">{{ authService.currentUser()?.username }}</span>
                    <span class="text-[9px] uppercase tracking-tighter text-text-dimmed">Profile</span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                (click)="onMobileLogout()"
                class="flex w-full items-center justify-center gap-2 rounded-xl border border-card-border-border bg-side-navigation-item-default-bg py-3 text-sm font-bold text-text-primary transition-colors hover:bg-side-navigation-item-hover-bg"
              >
                Logout
              </button>
            } @else {
              <a
                routerLink="/login"
                (click)="closeMobileMenu()"
                class="flex w-full items-center justify-center gap-2 rounded-xl bg-button-primary-default py-3 text-sm font-bold text-button-inverted-primary-default shadow-sm transition-colors hover:bg-button-primary-hover"
              >
                Sign In
              </a>
            }
          </div>
        </div>
      </nav>
    </div>
  }
</header>
